import _debounce from "lodash/debounce";
import { fetchTimeout, deepCopy, RehydrateThumbnails, deleteCookie } from "../components/Common";
import { API_BASE, PRICEFILE_KEY } from "../AppConfig";

import { createStoreDatabase, decryptData } from "./database";

import { NEW_JOB } from "./jobState";
import { loadOffering } from "./configState";
import * as JOBSTATE_VALIDATION from "./jobState_Validation";

// App Actions
export const UPDATE_USER = "UPDATE_USER";
export const UPDATE_BUSINESS = "UPDATE_BUSINESS";
export const UPDATE_LAST_QUOTES_EDITED = "UPDATE_LAST_QUOTES_EDITED";
export const UPDATE_LAST_QUOTES_EDITED_ARCHIVED = "UPDATE_LAST_QUOTES_EDITED_ARCHIVED";

// Page Actions
export const UPDATE_APP = "UPDATE_APP";
export const TOGGLE_APP = "TOGGLE_APP";
export const UPDATE_PAGE = "UPDATE_PAGE";
// Page Attributes
export const MAIN_PAGE = "MAIN_PAGE";
export const DESIGNER_PAGE = "DESIGNER_PAGE";

// Designer Actions
export const UPDATE_DESIGNER = "UPDATE_DESIGNER";
export const TOGGLE_DESIGNER = "TOGGLE_DESIGNER";
export const SET_TOOLSET_AREA = "setToolSetArea";
export const SHOW_LOADING_BACKDROP = "SHOW_LOADING_BACKDROP";
export const LOADING_BACKDROP_MESSAGE = "LOADING_BACKDROP_MESSAGE";
// Designer Attributes
export const MAIN_DRAWER_OPEN = "mainDrawerOpen";
export const TOOL_DRAWER_OPEN = "toolDrawerOpen";
export const TOOL_DRAWER_HIDE = "toolDrawerHide";
export const TOOL_DRAWER_AREA = "toolDrawerArea";
export const THREED_MODE = "threeDMode";
export const THREED_MINI_MODE = "threeDMiniMode";
export const THREED_MINI_WIDTH = "threeDMiniWidth";
export const THREED_MINI_HEIGHT = "threeDMiniHeight";
export const SHOW_CUSTOMER_JOB_PANEL = "showCustomerJobPanel";
export const SHOW_NOTES_PANEL = "showNotesPanel";
export const SHOW_DEBUG_TOOLS = "SHOW_DEBUG_TOOLS";
export const UNLOCKED = "UNLOCKED";
export const TOOL_DRAWER_WIDTH = "TOOL_DRAWER_WIDTH";

// 2D Designer Actions
export const UPDATE_2D_DESIGNER = "UPDATE_2D_DESIGNER";
export const UPDATE_2D_DESIGNER_SVGS = "UPDATE_2D_DESIGNER_SVGS";
export const TOGGLE_2D_DESIGNER = "TOGGLE_2D_DESIGNER";
export const SHOW_DESIGNER_MESSAGE = "SHOW_DESIGNER_MESSAGE";
export const CLEAR_DESIGNER_MESSAGE = "CLEAR_DESIGNER_MESSAGE";
export const APPEND_DESIGNER_MESSAGE = "APPEND_DESIGNER_MESSAGE";

export const SELECT_POINT = "SELECT_POINT";
export const SELECT_POINT_NOTE = "SELECT_POINT_NOTE";
export const SELECTED_POINT = "SELECTED_POINT";
export const SELECT_POINT_ALLOW_HIT_SELTYPE = "SELECT_POINT_ALLOW_HIT_SELTYPE";
export const AREA_INDEX = "AREA_INDEX";

// 2D Designer Attributes
export const SHOW_IMPORTED_MAP = "showImportedMap";
export const SHOW_BEAM_LENGTHS = "SHOW_BEAM_LENGTHS";
export const SHOW_POST_DIMENSIONS = "SHOW_POST_DIMENSIONS";
export const DRAW_FULL_LAYOUT = "DRAW_FULL_LAYOUT";

// 3D Designer Actions
export const UPDATE_3D_DESIGNER = "UPDATE_3D_DESIGNER";
export const TOGGLE_3D_DESIGNER = "TOGGLE_3D_DESIGNER";
export const UPDATE_3D_MODEL = "UPDATE_3D_MODEL";

// 3D Babylon Designer Attributes
export const SHOW_GROUND_PHOTO = "showGroundPhoto";
export const SHOW_HOUSE_MODEL = "showHouseModel";
export const SHOW_VERANDAH_MODEL = "showVerandahModel";
export const SHOW_VERANDAH_LAYOUT = "showVerandahLayout";
export const BABYLON_SELECTED_ITEM = "babylonSelectedItem";

export const ATTACHMENT_MESH_MODE = "ATTACHMENT_MESH_MODE";
export const ROOFSHEET__MESH_MODE = "ROOFSHEET__MESH_MODE";
export const BEAM_AND_POST_MESH_MODE = "BEAM_AND_POST_MESH_MODE";
export const GUTTERS_AND_FLASHING_MESH_MODE = "GUTTERS_AND_FLASHING_MESH_MODE";
export const FOOTINGS_MESH_MODE = "FOOTINGS_MESH_MODE";

export const VERANDAH_MESH_MODE = "verandahMeshMode";
export const VERANDAH_EDGE_LINE_MODE = "verandahEdgeLineMode";
export const BACKGROUND_MODE = "backgroundMode";
export const BACKGROUND_SHADOW_MODE = "backgroundShadowMode";
export const RENDERQUALITYFACTOR = "RENDERQUALITYFACTOR";
export const SUN_ANGLE = "SUN_ANGLE";
export const SUN_ANGLE_Y = "SUN_ANGLE_Y";
export const FONT_SIZE = "FONT_SIZE";
export const SHOW_GRAPH_BG = "SHOW_GRAPH_BG";
export const SHOW_DISPLAY_OPTIONS = "SHOW_DISPLAY_OPTIONS";

export const DRAWER_TOOLSET_EXPANDED = "drawerToolSetExpanded";

export const ATTACHMENT_TOOL = "attachment_tool";
export const GUTTERS_DOWNPIPES_TOOL = "gutters_downpipes_tool";
export const ROOFSHEET_TOOL = "roofsheet_tool";
export const BEAMS_AND_POSTS_TOOL = "beams_and_posts_tool";
export const PITCHED_GABLE_TOOL = "pitched_gable_tool";
export const OTHER_TOOLS = "OTHER_TOOLS";

export const SHAPE_TOOL = "SHAPE_TOOL";
export const SHOW_LOADING_BAR = "SHOW_LOADING_BAR";
export const SHOW_WIND_DATA_LOADING_BAR = "SHOW_WIND_DATA_LOADING_BAR";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const MESSAGE = "MESSAGE";
export const SHOW_DIALOG = "SHOW_DIALOG";
export const DIALOG_DATA = "DIALOG_DATA";
export const DOCUMENT_TO_SHOW = "DOCUMENT_TO_SHOW";
export const GENERATING_DOCUMENT = "GENERATING_DOCUMENT";
export const GENERATING_DOCUMENT_STATUS = "GENERATING_DOCUMENT_STATUS";

export const initialState = {
    page: MAIN_PAGE,
    MAIN_PAGE: {
        page: "Recall",
        NumRecallItems: 50,
    },
    help_open: false,
    help_section: null,
    designer: {
        [TOOL_DRAWER_OPEN]: false,
        [TOOL_DRAWER_HIDE]: false,
        [MAIN_DRAWER_OPEN]: false,
        [TOOL_DRAWER_AREA]: 0,
        [THREED_MODE]: false,
        [THREED_MINI_MODE]: false,
        [THREED_MINI_HEIGHT]: window.innerHeight * 0.45,
        [THREED_MINI_WIDTH]: window.innerWidth * 0.55,
        [SHOW_CUSTOMER_JOB_PANEL]: false,
        [SHOW_NOTES_PANEL]: false,
        [SHOW_LOADING_BAR]: true,
        [SHOW_LOADING_BACKDROP]: false,
        [SHOW_DEBUG_TOOLS]: false,
        [LOADING_BACKDROP_MESSAGE]: "",
        [SHOW_DIALOG]: false,
        [DIALOG_DATA]: {},
        [SHOW_MESSAGE]: false,
        [DOCUMENT_TO_SHOW]: null,
        [GENERATING_DOCUMENT]: false,
        [GENERATING_DOCUMENT_STATUS]: false,
        [MESSAGE]: "",
        [SHOW_DISPLAY_OPTIONS]: false,
        [UNLOCKED]: false,
        [TOOL_DRAWER_WIDTH]: 390,
        designer2D: {
            [SHOW_IMPORTED_MAP]: false,
            [SHOW_BEAM_LENGTHS]: false,
            [SHOW_POST_DIMENSIONS]: false,
            [DRAW_FULL_LAYOUT]: false,
            [FONT_SIZE]: 100,
            [SHOW_GRAPH_BG]: true,
            [SELECT_POINT_NOTE]: "",
            [AREA_INDEX]: -1,
            [SELECT_POINT]: false,
            [SELECT_POINT_ALLOW_HIT_SELTYPE]: false,
            [SELECTED_POINT]: { x: 0, y: 0 },
            svgs: {
                area_all: null,
            },
        },
        designer3D: {
            [SHOW_GROUND_PHOTO]: true,
            [SHOW_HOUSE_MODEL]: true,
            [SHOW_VERANDAH_MODEL]: false,
            [ATTACHMENT_MESH_MODE]: "Render",
            [ROOFSHEET__MESH_MODE]: "Render",
            [BEAM_AND_POST_MESH_MODE]: "Render",
            [GUTTERS_AND_FLASHING_MESH_MODE]: "Render",
            [FOOTINGS_MESH_MODE]: "Render",
            [VERANDAH_MESH_MODE]: false,
            [VERANDAH_EDGE_LINE_MODE]: false,
            [SHOW_VERANDAH_LAYOUT]: false,
            [BABYLON_SELECTED_ITEM]: null,
            [DRAWER_TOOLSET_EXPANDED]: null,
            [BACKGROUND_SHADOW_MODE]: false,
            [BACKGROUND_SHADOW_MODE]: false,
            [BACKGROUND_MODE]: "Grid",
            [RENDERQUALITYFACTOR]: 7,
            [SUN_ANGLE]: 1,
            [SUN_ANGLE_Y]: -1,
            objs: {
                area_all: null,
            },
        },
    },
    user: null,
    logged_user_code: null,
    user_last_jobs_edited: null,
    user_last_jobs_edited_archived: null,
    offerings: null,
    online: true,
    manufacturer: window?.F
        ? {
              Name: "Centenary",
              ProductName: "Centenary",
              FullRegisteredName: "Fielders Pty Ltd",
              Logo: "/app/images/centenary_logo.png",
              BrandColour: "rgb(0, 52, 102)",
              SoftwareName: "Centenary Design Suite",
          }
        : {
              Name: "Lysaght",
              ProductName: "Lysaght Living",
              FullRegisteredName: "Bluescope Steel Limited",
              Logo: "/images/lys_logo_topbar.png",
              BrandColour: "#066CB6",
              SoftwareName: "Lysaght Living Designer",
          },
    job_history_buffer: {
        data: [],
        pointer: -1,
    },
};

export default function (state = initialState, action) {
    switch (action.type) {
        case UPDATE_APP:
            return {
                ...state,
                [action.parameter]: action.value,
            };
        case TOGGLE_APP:
            let toggle_app_value =
                action.value || action.value === false ? action.value : !state[action.parameter] ? true : false;
            return {
                ...state,
                [action.parameter]: toggle_app_value,
            };
        case UPDATE_PAGE:
            return {
                ...state,
                page: action.value,
            };
        case UPDATE_USER:
            return {
                ...state,
                user: action.value,
            };
        case UPDATE_BUSINESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    BusinessCode: action?.value?.id,
                    BusinessDetails: action.value,
                },
            };

        case UPDATE_LAST_QUOTES_EDITED:
            return {
                ...state,
                user_last_jobs_edited: action.value,
            };

        case UPDATE_LAST_QUOTES_EDITED_ARCHIVED:
            return {
                ...state,
                user_last_jobs_edited_archived: action.value,
            };

        case UPDATE_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [action.parameter]: action.value,
                },
            };

        case TOGGLE_DESIGNER:
            let value =
                action.value || action.value === false
                    ? action.value
                    : !state.designer[action.parameter]
                    ? true
                    : false;
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [action.parameter]: value,
                },
            };
        case UPDATE_2D_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        [action.parameter]: action.value,
                    },
                },
            };
        case UPDATE_2D_DESIGNER_SVGS:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        svgs: {
                            ...state.designer.designer2D.svgs,
                            [action.parameter]: action.value,
                        },
                    },
                },
            };
        case UPDATE_3D_MODEL:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        objs: {
                            ...state.designer.designer3D.objs,
                            [action.parameter]: action.value,
                        },
                    },
                },
            };
        case TOGGLE_2D_DESIGNER:
            let value_TOGGLE_2D_DESIGNER =
                action.value || action.value === false
                    ? action.value
                    : !state.designer.designer2D[action.parameter]
                    ? true
                    : false;

            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer2D: {
                        ...state.designer.designer2D,
                        [action.parameter]: value_TOGGLE_2D_DESIGNER,
                    },
                },
            };
        case UPDATE_3D_DESIGNER:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        [action.parameter]: action.value,
                    },
                },
            };
        case TOGGLE_3D_DESIGNER:
            let value_TOGGLE_3D_DESIGNER =
                action.value || action.value === false
                    ? action.value
                    : !state.designer.designer3D[action.parameter]
                    ? true
                    : false;

            return {
                ...state,
                designer: {
                    ...state.designer,
                    designer3D: {
                        ...state.designer.designer3D,
                        [action.parameter]: value_TOGGLE_3D_DESIGNER,
                    },
                },
            };
        case SET_TOOLSET_AREA:
            let toolset = state.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
            if (action.toolset !== null) {
                // if (toolset == action.toolset) toolset = null;
                // else
                toolset = action.toolset;
            }

            return {
                ...state,
                designer: {
                    ...state.designer,
                    [TOOL_DRAWER_AREA]: action.area,
                    designer3D: {
                        ...state.designer.designer3D,
                        [DRAWER_TOOLSET_EXPANDED]: toolset,
                    },
                },
            };

        case CLEAR_DESIGNER_MESSAGE:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: false,
                    [MESSAGE]: "",
                },
            };
        case SHOW_DESIGNER_MESSAGE:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: true,
                    [MESSAGE]: action.message,
                },
            };
        case APPEND_DESIGNER_MESSAGE:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_MESSAGE]: true,
                    [MESSAGE]: (state.designer.message ? state.designer.message + "<br />" : "") + action.message,
                },
            };
        case SHOW_DIALOG:
            return {
                ...state,
                designer: {
                    ...state.designer,
                    [SHOW_DIALOG]: true,
                    [DIALOG_DATA]: action.value,
                },
            };

        default:
            return state;
    }
}

export const showDialog =
    (title, message, primaryActionText = "Close", primaryAction, secondaryActionText, secondaryAction) =>
    (dispatch) => {
        dispatch({
            type: SHOW_DIALOG,
            value: {
                title: title,
                message: message,
                primaryActionText: primaryActionText,
                primaryAction: primaryAction,
                secondaryActionText: secondaryActionText,
                secondaryAction: secondaryAction,
            },
        });
    };
export const showDialogData = (dialogData) => (dispatch) => {
    let defaultData = {
        title: "",
        message: "",
        primaryActionText: "OK",
        primaryAction: null,
        secondaryActionText: null,
        secondaryAction: null,
    };

    dispatch({
        type: SHOW_DIALOG,
        value: {
            ...defaultData,
            ...dialogData,
        },
    });
};

export const UNDO = () => (dispatch) => {
    dispatch({
        type: "UNDO",
    });
};
export const REDO = () => (dispatch) => {
    dispatch({
        type: "REDO",
    });
};

export const loadAppTemplate = (template) => (dispatch) => {
    console.log("LOAD_TEMPLATE");
    dispatch({
        type: "LOAD_TEMPLATE",
        value: template,
    });
};

export const resetAll = () => (dispatch) => {
    console.log("RESET_ALL");
    dispatch({
        type: "RESET_ALL",
        value: "RESET_ALL",
    });
};

export const updateAPP = (parameter, value) => (dispatch) => {
    console.log("updateAPP", parameter, value);
    return new Promise((resolve) => {
        dispatch({
            type: UPDATE_APP,
            parameter: parameter,
            value: value,
        });
        return resolve(true);
    });
};

export const toggleAPP =
    (parameter, value = null) =>
    (dispatch) => {
        // console.log("toggleApp", parameter, value);
        return new Promise((resolve) => {
            dispatch({
                type: TOGGLE_APP,
                parameter: parameter,
                value: value,
            });
            return resolve(true);
        });
    };

export const resetDesigner = () => (dispatch, getState) => {
    const job = getState().job;
    const carportMode = job?.DesignParameters?.CarportMode === 1;
    dispatch({
        type: UPDATE_APP,
        parameter: "designer",
        value: {
            ...initialState.designer,
            threeDMode: window.debug && !carportMode ? true : false,
            threeDMiniMode: window.debug && !carportMode ? true : false,
            designer2D: { ...getState()?.app?.designer?.designer2D, AREA_INDEX: -1, SELECT_POINT: false },
            designer3D: { ...getState()?.app?.designer?.designer3D },
        },
    });
    return Promise.resolve();
};

export const loadUser = (email_address, password) => (dispatch) => {
    return new Promise((resolve) => {
        dispatch(updateUserFromWeb(email_address, password)).then((user_data) => {
            // console.log("user_data", user_data);
            if (!user_data) {
                return resolve(false);
            }
            if (user_data.Error) {
                return resolve(user_data);
            }

            dispatch({
                type: UPDATE_APP,
                parameter: "logged_user_code",
                value: email_address,
            });

            let config_url = API_BASE() + `config/` + btoa(email_address);
            // if (window.debug) config_url = BaseURL("data/config_data_response.json");

            if (!window.location.href.includes("use_cache")) {
                fetchTimeout(config_url, {
                    method: "GET", // *GET, POST, PUT, DELETE, etc.
                })
                    .then((res) => res.json())
                    .then(async (json_user_data) => {
                        console.log("json_user_data", json_user_data);

                        if (!json_user_data?.offerings) throw "No offering data";

                        // dispatch(updateConfigAll({
                        //     ...json_user_data.offerings.Fielders.Master,
                        //     validationSchema: {
                        //         ...json_user_data.offerings.Fielders.validationSchema,
                        //     }
                        // }));

                        let offering = null;
                        if (window.FIELDERS && json_user_data?.offerings?.Fielders)
                            offering = json_user_data?.offerings?.Fielders;
                        if (window.LYSAGHT && json_user_data?.offerings?.Lysaght)
                            offering = json_user_data?.offerings?.Lysaght;

                        console.log("offering", offering);

                        if (offering)
                            dispatch(updateAPP("offerings", json_user_data.offerings)).then(() => {
                                dispatch(loadOffering());
                            });
                        if (json_user_data?.pricefile) {
                            if (json_user_data?.pricefile?.Error)
                                dispatch({
                                    type: SHOW_DESIGNER_MESSAGE,
                                    message: json_user_data?.pricefile?.Error,
                                });
                            else {
                                const encryptedPricefile = json_user_data?.pricefile;

                                console.log(encryptedPricefile);

                                let decryptedPricefile;
                                // Decrypt the encrypted data
                                if (encryptedPricefile?.data && encryptedPricefile?.iv)
                                    decryptedPricefile = JSON.parse(
                                        decryptData(
                                            encryptedPricefile.data, // Access the "data" property that contains the encrypted data
                                            encryptedPricefile.iv,
                                            PRICEFILE_KEY // Encyrption Key
                                        )
                                    );

                                // console.log(decryptedPricefile); // not logged for security reasons

                                const encyrptedPricefile = json_user_data?.pricefile;

                                createStoreDatabase(JSON.stringify(encyrptedPricefile));
                                // sessionStorage.setItem("pricefile", encyrptedPricefile);
                                dispatch(updateAPP("pricefile", RehydrateThumbnails(decryptedPricefile)));
                            }
                        }
                        if (json_user_data?.dist_level) dispatch(updateAPP("dist_levels", json_user_data?.dist_level));
                        if (json_user_data?.special_factors)
                            dispatch(updateAPP("special_factors", json_user_data?.special_factors));
                        if (json_user_data?.announcements)
                            dispatch(updateAPP("announcements", json_user_data?.announcements));
                        resolve(true);
                    })
                    .catch((e) => {
                        resolve({
                            Error: "Server Error: Could not load offerings from Server",
                        });
                    });
            }

            //   updateRecallListFromWeb(user_data);
        });
    });
};

export const changePage = (page_name) => (dispatch) => {
    window.history.pushState({ page: page_name }, page_name, window.location);
    dispatch({
        type: UPDATE_PAGE,
        value: page_name,
    });

    if (page_name === MAIN_PAGE)
        dispatch({
            type: NEW_JOB,
            parameter: null,
        });
};

export const changeMainPage =
    (page_name, record_state = true) =>
    (dispatch, getState) => {
        if (record_state) window.history.pushState({ MAIN_PAGE: { page: page_name } }, page_name, window.location);

        let new_state = { ...getState().app[MAIN_PAGE] };
        new_state.page = page_name;
        new_state._ts = Date.now();

        dispatch({
            type: UPDATE_APP,
            parameter: MAIN_PAGE,
            value: new_state,
        });
    };

export const SetAppDialogMessage = (message) => (dispatch, getState) => {
    let new_state = { ...getState().app[MAIN_PAGE] };
    new_state.Message = message;

    dispatch({
        type: UPDATE_APP,
        parameter: MAIN_PAGE,
        value: new_state,
    });
};

export const updateUserFromWeb =
    (email_ddress_id, password = null) =>
    (dispatch) => {
        checkInternetConnection(dispatch);

        return new Promise((resolve) => {
            fetchTimeout(API_BASE() + "user/" + btoa(email_ddress_id) + (password ? "/" + password : ""), {
                // fetchTimeout(API_BASE() + "user/" + email_ddress, {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            })
                .then(async (response) => {
                    if (response.status >= 200 && response.status <= 300) {
                        let user_data = await response.json();
                        // if (user_data?.BusinessDetails?.Brand) {
                        //   window.brand = user_data?.BusinessDetails?.Brand;
                        //   if (window.brand === "Fielders") {
                        //     window.FIELDERS = true;
                        //     window.LYSAGHT = false;
                        //   } else if (window.brand === "Lysaght") {
                        //     window.FIELDERS = false;
                        //     window.LYSAGHT = true;
                        //   }
                        // }
                        dispatch(updateUser(user_data));
                        resolve(user_data);
                    } else if (response.status === 401) {
                        let error = await response.json();
                        console.log("error", error);
                        resolve(error);
                        return;
                    } else resolve(false);
                })
                .then(async (response) => {
                    if (response.status >= 200 && response.status <= 300) {
                        let user_data = await response.json();
                        console.log("user_data", user_data);
                        if (user_data?.BusinessDetails?.Brand && window.debug) {
                            window.brand = user_data?.BusinessDetails?.Brand;
                            if (window.brand === "Fielders") {
                                window.FIELDERS = true;
                                window.LYSAGHT = false;
                            } else if (window.brand === "Lysaght") {
                                window.FIELDERS = false;
                                window.LYSAGHT = true;
                            }
                        }
                        dispatch(updateUser(user_data));
                        resolve(user_data);
                    } else if (response.status === 401) {
                        let error = await response.json();
                        console.log("error", error);
                        resolve(error);
                        return;
                    } else resolve(false);
                })
                .catch((e) => {
                    resolve({
                        Error: "Server Error: Could not load user from Server",
                    });
                });
        });
    };

export const updateRecallListFromWeb =
    (businessCode, status = "", container = "") =>
    (dispatch, getState) => {
        console.log("updateRecallListFromWeb");
        checkInternetConnection(dispatch);
        const num_items = getState().app[MAIN_PAGE].NumRecallItems;

        return new Promise((resolve) => {
            fetchTimeout(API_BASE() + `job/` + businessCode, {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                body: JSON.stringify({
                    Status: status,
                    Container: container,
                    NumItems: num_items,
                }),
            })
                .then(async (res) => {
                    if (res.status >= 200 && res.status <= 300) {
                        let json_recall_data = await res.json();
                        if (status === "ARCHIVED") dispatch(updateLastQuotesEditedArchived(json_recall_data[0]?.Jobs));
                        else dispatch(updateLastQuotesEdited(json_recall_data[0]?.Jobs));
                        resolve("OK");
                    } else {
                        console.log("updateRecallListFromWeb: Error reading recall list");
                    }
                })
                .catch((e) => {});

            updateAnnouncements()(dispatch);
        });
    };

export const updateAnnouncements = () => (dispatch) => {
    checkInternetConnection(dispatch);

    let api_url = API_BASE() + "admin/getannouncements/";
    if (window.LYSAGHT) api_url = API_BASE() + "admin/getannouncements/?b=L";
    fetchTimeout(api_url, {
        method: "GET",
    })
        .then((response) => response.json())
        .then((json) => {
            if (json.Message) throw json.Message;
            dispatch(updateAPP("announcements", json));
        })
        .catch((e) => {
            console.log("ERROR", e);
        });
};

export const updateUser = (user_data) => (dispatch, getState) => {
    checkInternetConnection(dispatch);

    console.log("loading user...", user_data);
    dispatch({
        type: UPDATE_USER,
        value: user_data,
    });

    let job = getState().job;

    if (job) {
        let new_job = deepCopy(job);
        new_job = JOBSTATE_VALIDATION.validateFullJob(getState().config, new_job, -1, getState().app);

        dispatch({
            type: "NEW_JOB",
            parameter: new_job,
        });
    }
};

export const updateBusiness = (businessDetails) => (dispatch) => {
    dispatch({
        type: UPDATE_BUSINESS,
        value: businessDetails,
    });
};

export const saveUserToWeb =
    (user_data, update_local_data = false, update_business = false) =>
    (dispatch) => {
        checkInternetConnection(dispatch);

        if (update_local_data) dispatch(updateUser(user_data));

        let savejob_url = API_BASE() + "user/" + btoa(user_data.id);
        if (update_business) savejob_url += "/UpdateBusiness";

        console.log("saving user...", user_data);
        return fetchTimeout(savejob_url, {
            method: "PUT", // *GET, POST, PUT, DELETE, etc.
            body: JSON.stringify(user_data), // body data type must match "Content-Type" header
        });
    };

export const updateLastQuotesEdited = (jobs_data) => (dispatch) => {
    dispatch({
        type: UPDATE_LAST_QUOTES_EDITED,
        value: jobs_data,
    });
};

export const updateLastQuotesEditedArchived = (jobs_data) => (dispatch) => {
    dispatch({
        type: UPDATE_LAST_QUOTES_EDITED_ARCHIVED,
        value: jobs_data,
    });
};

export const updateDesigner = (parameter, value) => (dispatch) => {
    console.log(UPDATE_DESIGNER, parameter, value);
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: parameter,
        value: value,
    });
    return Promise.resolve();
};
export const toggleDesigner = (parameter) => (dispatch) => {
    console.log(TOGGLE_DESIGNER, parameter);
    dispatch({
        type: TOGGLE_DESIGNER,
        parameter: parameter,
    });
    return Promise.resolve();
};

export const setDesignerLoadingBackdrop = (message) => (dispatch) => {
    console.log(TOGGLE_DESIGNER, message);

    if (!message) {
        dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
        return Promise.resolve();
    }
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: SHOW_LOADING_BACKDROP,
        value: true,
    });
    dispatch({
        type: UPDATE_DESIGNER,
        parameter: LOADING_BACKDROP_MESSAGE,
        value: message,
    });
    return Promise.resolve();
};

export const getImageBlob = function (url) {
    return new Promise(async (resolve) => {
        try {
            let resposne = await fetchTimeout(url, {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            });
            let blob = resposne.blob();
            resolve(blob);
        } catch (e) {
            console.log("error getImageBlob", e);
            resolve(false);
        }
    });
};

// convert a blob to base64
export const blobToBase64 = function (blob) {
    return new Promise((resolve) => {
        let reader = new FileReader();
        reader.onload = function () {
            let dataUrl = reader.result;
            resolve(dataUrl);
        };
        reader.readAsDataURL(blob);
    });
};

export const checkInternetConnection = (dispatch) => {
    if (window.OFFLINE_MODE) {
        if (!window.OFFLINE_SET) {
            window.OFFLINE_SET = true;
            dispatch({
                type: UPDATE_APP,
                parameter: "online",
                value: true,
            });
        }
        return;
    }
    if (document.hidden) return;
    var connected = window.navigator.onLine;
    if (connected) {
        if (window.checkingConnection > 0) {
            window.checkingConnection--;
            return;
        }
        // are you sure?
        // // check server
        window.checkingConnection = 3;

        fetchTimeout(
            API_BASE() + "isalive/ping",
            {
                method: "GET", // *GET, POST, PUT, DELETE, etc.
            },
            5000
        )
            .then(async (response) => {
                if (response.status >= 200 && response.status <= 300) {
                    connected = true;
                    window.checkingConnectionFailed = 0;
                    window.tokenexpired = 0;
                    dispatch({
                        type: UPDATE_APP,
                        parameter: "online",
                        value: true,
                    });

                    try {
                        // want to store reponse in global variable, to avoid react or redux incase of error.
                        let json = await response.json();
                        window.settings = json;
                    } catch {}
                } else {
                    console.log("checked Connection: failed", response.status);
                    if ((response, response.status === 401)) {
                        let response_text = await response.text();
                        if (response_text.includes("TOKEN DENIED")) {
                            console.log("tokenexpired", window.tokenexpired);
                            if (window.tokenexpired) window.tokenexpired++;
                            else window.tokenexpired = 1;

                            if (window.tokenexpired >= 5) {
                                //logout and redirect to auth
                                deleteCookie("CDS_token");
                                localStorage.clear();
                                dispatch({
                                    type: "LOG_OUT",
                                });
                                localStorage.clear();
                                setTimeout(function () {
                                    localStorage.clear();
                                    // window.location.reload();
                                    window.location.href = "/auth/";
                                }, 1000);
                            }
                        }
                    }
                    throw false;
                }
                window.checkingConnection = false;
            })
            .catch((e) => {
                if (!window?.checkingConnectionFailed) window.checkingConnectionFailed = 0;
                window.checkingConnectionFailed++;
                window.checkingConnection = false;
                if (window.checkingConnectionFailed > 3) {
                    dispatch({
                        type: TOGGLE_DESIGNER,
                        parameter: SHOW_LOADING_BAR,
                        value: false,
                    });
                    dispatch({
                        type: UPDATE_APP,
                        parameter: "online",
                        value: false,
                    });
                    setTimeout(function () {
                        checkInternetConnection(dispatch);
                    }, 3000);
                } else {
                    setTimeout(function () {
                        checkInternetConnection(dispatch);
                    }, 2000);
                }
            });
    } else if (!connected) {
        dispatch({
            type: UPDATE_APP,
            parameter: "online",
            value: false,
        });
        dispatch({
            type: TOGGLE_DESIGNER,
            parameter: SHOW_LOADING_BAR,
            value: false,
        });
        dispatch({
            type: SHOW_DESIGNER_MESSAGE,
            message: "INTERNET NOT CONNECTED. Check your connection and try again.",
        });
        window.checkingConnection = false;
        setTimeout(function () {
            checkInternetConnection(dispatch);
        }, 1000);
    }
    return connected;
};

// export const updateLayout3D_old = () => (dispatch, getState) => {
//     checkInternetConnection(dispatch);

//     let user_id = getState().app.user.id;
//     let online = getState().app.online;
//     if (!online) return;
//     if (document.hidden) return;

//     // if (!checkInternetConnection(dispatch)) {
//     //     return;
//     // }

//     let job_data = getState().job;
//     if (!job_data) {
//         dispatch({
//             type: TOGGLE_DESIGNER,
//             parameter: SHOW_LOADING_BAR,
//             value: false,
//         });
//         return;
//     }
//     if (!job_data?.AreaSpecifications?.length) {
//         dispatch({
//             type: TOGGLE_DESIGNER,
//             parameter: SHOW_LOADING_BAR,
//             value: false,
//         });
//         return;
//     }

//     dispatch({
//         type: TOGGLE_DESIGNER,
//         parameter: SHOW_LOADING_BAR,
//         value: true,
//     });

//     let job_ini = convertJobStateToIni(job_data, getState().app, "3D", getState().config);

//     let id = getState().job.id;

//     let api_url = API_BASE() + "obj/" + id;

//     setTimeout(() => {
//         loadingMeshMode();
//     }, 2000);

//     window.loading3d = true;
//     let request_id = Date.now();
//     window.loading3d_id = request_id;

//     if (window.loading3d_controller) window.loading3d_controller.abort();
//     if (window.AbortController) window.loading3d_controller = new AbortController();

//     let timeout = 12000;
//     if (job_data?.DesignParameters) {
//         if (window.debug) {
//             timeout =
//                 6000 +
//                 job_data.DesignParameters.NumFlat * 3000 +
//                 job_data.DesignParameters.NumGable * 4000 +
//                 job_data.DesignParameters.NumDeck * 3000;
//         } else {
//             timeout =
//                 6000 +
//                 job_data.DesignParameters.NumFlat * 2500 +
//                 job_data.DesignParameters.NumGable * 3500 +
//                 job_data.DesignParameters.NumDeck * 2500;
//         }
//     }

//     console.log("3d timeout", timeout);

//     return fetchTimeout(
//         api_url,
//         {
//             signal: window?.loading3d_controller?.signal,
//             headers: {
//                 "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//                 user_id: user_id,
//                 job_id: job_data.id,
//                 job: job_ini,
//                 request_id: request_id,
//                 session_id: window?.session_id,
//                 business_code: job_data?.BusinessCode,
//             }),
//             retry: true,
//             retry_timeout: timeout * 1.3,
//             request_id: request_id,
//         },
//         timeout
//     )
//         .then(async (response) => {
//             console.log("RESPONSE", response);

//             if (response === undefined) {
//                 dispatch({
//                     type: TOGGLE_DESIGNER,
//                     parameter: SHOW_LOADING_BAR,
//                     value: false,
//                 });
//                 return;
//             }

//             let json = await response.json();

//             if (json.request_id != window.loading3d_id) return;
//             if (response === undefined) return;

//             window.loading3d = false;
//             if (json.Error) {
//                 throw json.Error;
//             }
//             if (json.obj_url) {
//                 dispatch({
//                     type: UPDATE_3D_MODEL,
//                     parameter: "area_all",
//                     value: json.obj_url,
//                 });

//                 if (json.Locked) {
//                     if (job_data) {
//                         let new_job = deepCopy(job_data);

//                         new_job.App.Locked = true;
//                         new_job.App.LockMessage = json.LockMessage;

//                         dispatch({
//                             type: NEW_JOB,
//                             parameter: new_job,
//                         });
//                     }
//                 }
//             } else {
//                 dispatch({
//                     type: TOGGLE_DESIGNER,
//                     parameter: SHOW_LOADING_BAR,
//                     value: false,
//                 });
//             }
//         })
//         .catch((e) => {
//             if (e?.message?.includes && e.message.includes("aborted")) {
//                 return;
//             }

//             window.loading3d = false;

//             console.log("3D ERROR", e);

//             let message = "Error loading model from QikQuote server.";
//             if (e?.message) message = e.message;
//             if (e.message === "failed to fetch")
//                 message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
//             dispatch({
//                 type: TOGGLE_DESIGNER,
//                 parameter: SHOW_LOADING_BAR,
//                 value: false,
//             });
//             dispatch({
//                 type: SHOW_DESIGNER_MESSAGE,
//                 message: "Error: " + message,
//             });

//             // handle errors and timeout error
//         }); // parses JSON response into native Javascript objects
// };

// export const updateLayout2D_old =
//     (mode = null, area_index = null, drawing_mode = null, force = false) =>
//     (dispatch, getState) => {
//         if (window.debug && window.location.href.includes("no_eng") && !force) {
//             dispatch({
//                 type: TOGGLE_DESIGNER,
//                 parameter: SHOW_LOADING_BAR,
//                 value: false,
//             });
//             return;
//         }
//         window.loading3d = false;
//         console.log("updateLayout2D");
//         checkInternetConnection(dispatch);
//         if (document.hidden) return;

//         let online = getState().app.online;

//         if (area_index === null) area_index = getState().app?.designer?.designer2D?.AREA_INDEX;
//         if (!online)
//             return new Promise((resolve) => {
//                 return resolve(false);
//             });

//         let user_id = getState().app.user.id;
//         let job_data = getState().job;
//         if (!job_data) {
//             console.log("no job data");
//             dispatch({
//                 type: TOGGLE_DESIGNER,
//                 parameter: SHOW_LOADING_BAR,
//                 value: false,
//             });
//             return new Promise((resolve) => {
//                 return resolve(false);
//             });
//         }

//         if (!job_data.AreaSpecifications.length === 0) {
//             console.log("no area data");
//             dispatch({
//                 type: TOGGLE_DESIGNER,
//                 parameter: SHOW_LOADING_BAR,
//                 value: false,
//             });
//             return new Promise((resolve) => {
//                 return resolve(false);
//             });
//         }

//         dispatch({
//             type: TOGGLE_DESIGNER,
//             parameter: SHOW_LOADING_BAR,
//             value: true,
//         });

//         // console.log("job_data", deepCopy(job_data), job_ini);

//         const toolopen = getState().app.designer.designer3D[DRAWER_TOOLSET_EXPANDED];
//         const select_point = getState().app.designer.designer2D[SELECT_POINT];
//         const draw_full_layout = getState().app.designer.designer2D[DRAW_FULL_LAYOUT];

//         let id = getState().job.id;

//         let api_url = API_BASE() + "svg/" + id + "/selection";
//         if (job_data.DesignParameters.DeckMode === 1) {
//             api_url = API_BASE() + "svg/" + id + "/selection";
//         } else if (toolopen === SHAPE_TOOL && job_data.DesignParameters.DeckMode !== 1 && !draw_full_layout) {
//             api_url = API_BASE() + "svg/" + id + "/";
//         } else if (toolopen === BEAMS_AND_POSTS_TOOL && area_index === -1 && !select_point) {
//             api_url = API_BASE() + "svg/" + id + "/engineering";
//             if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
//                 api_url = API_BASE() + "svg/" + id + "/selection";
//                 dispatch({
//                     type: SHOW_DESIGNER_MESSAGE,
//                     message: "Error: Wind data must be defined to engineer this design",
//                 });
//             }
//         }

//         if (drawing_mode && drawing_mode === "engineering") {
//             api_url = API_BASE() + "svg/" + id + "/engineering";
//             if (!job_data?.SiteParameters?.WindData?.WindZoneAS1170) {
//                 api_url = API_BASE() + "svg/" + id + "/selection";
//                 dispatch({
//                     type: SHOW_DESIGNER_MESSAGE,
//                     message: "Error: Wind data must be defined to engineer this design",
//                 });
//             }
//         }

//         // if (api_url.includes("/engineering")) {
//         //     job_data = deepCopy(job_data);
//         //     job_data.SiteParameters.SpliceOffset = 0;
//         // }

//         let job_ini = convertJobStateToIni(job_data, getState().app, "", getState().config);

//         let request_id = Date.now();
//         window.loading2d_id = request_id;
//         if (window.loading2d_controller) window.loading2d_controller.abort();
//         if (window.AbortController) {
//             window.loading2d_controller = new AbortController();
//         }

//         if (mode) api_url = API_BASE() + "svg/" + id + "/" + mode;

//         console.log(api_url);

//         let timeout = 30000;
//         if (job_data?.DesignParameters) {
//             timeout =
//                 6000 +
//                 job_data.DesignParameters.NumFlat * 2000 +
//                 job_data.DesignParameters.NumGable * 3000 +
//                 job_data.DesignParameters.NumDeck * 2000;
//         }

//         if (api_url.includes("/engineering")) {
//             timeout = timeout * 2;
//         }

//         console.log("2d timeout", timeout);

//         return new Promise((resolve) => {
//             fetchTimeout(
//                 api_url,
//                 {
//                     signal: window?.loading2d_controller?.signal,
//                     headers: {
//                         "Content-Type": "application/json",
//                     },
//                     body: JSON.stringify({
//                         user_id: user_id,
//                         job_id: job_data.id,
//                         request_id: request_id,
//                         job: job_ini,
//                         wind_data: job_data?.SiteParameters?.WindData,
//                         area_index: area_index,
//                         session_id: window?.session_id,
//                         business_code: job_data?.BusinessCode,
//                         brand: window.LYSAGHT ? "Lysaght" : "Fielders",
//                     }),
//                     retry: true,
//                     retry_timeout: timeout * 2,
//                     request_id: request_id,
//                 },
//                 timeout
//             )
//                 .then(async (response) => {
//                     console.log("RESPONSE", response);

//                     if (response === undefined) {
//                         dispatch({
//                             type: TOGGLE_DESIGNER,
//                             parameter: SHOW_LOADING_BAR,
//                             value: false,
//                         });
//                         return resolve(false);
//                     }

//                     let json = await response.json();

//                     // .then(json => {
//                     console.log(json, window.loading2d_id);
//                     if (json.request_id != window.loading2d_id) {
//                         return resolve(false);
//                     }
//                     if (json.Error) {
//                         if (json.Locked) {
//                             if (job_data) {
//                                 let new_job = deepCopy(job_data);

//                                 new_job.App.Locked = true;
//                                 new_job.App.LockMessage = json.Error;

//                                 dispatch({
//                                     type: NEW_JOB,
//                                     parameter: new_job,
//                                 });
//                             }

//                             dispatch({
//                                 type: TOGGLE_DESIGNER,
//                                 parameter: SHOW_LOADING_BAR,
//                                 value: false,
//                             });
//                         } else {
//                             throw json.Error;
//                         }
//                     }
//                     window.svg_data = null;
//                     if (json["svg_data"]) {
//                         window.job = { ...getState().job };
//                         window.svg_data = json["svg_data"];

//                         dispatch({
//                             type: TOGGLE_DESIGNER,
//                             parameter: SHOW_LOADING_BAR,
//                             value: false,
//                         });

//                         console.log("json.svg", json.svg);
//                         var svg_url = json["svg"];
//                         // if ("Data" in json) {
//                         //     dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
//                         // }

//                         // dispatch({
//                         //     type: UPDATE_2D_DESIGNER_SVGS,
//                         //     parameter: "area_all",
//                         //     value: svg_url,
//                         // });

//                         LoadSVGFromData(json["svg_data"], svg_url);

//                         setTimeout(function () {
//                             dispatch({
//                                 type: TOGGLE_DESIGNER,
//                                 parameter: SHOW_LOADING_BAR,
//                                 value: false,
//                             });

//                             dispatch(updateAPP("loadingEngineering", false));

//                             if ("Data" in json) {
//                                 dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
//                             }
//                             if ("EngineeringResults" in json) {
//                                 let new_engineering = {
//                                     ...getState().job.QuoteParameters.ENGINEERING,
//                                     ...json,
//                                 };
//                                 window.job = { ...getState().job };
//                                 new_engineering.engineeringHashCode = GetShapeUpdateString();

//                                 new_engineering.EngineeringResults = json["EngineeringResults"];
//                                 dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

//                                 setTimeout(function () {
//                                     let job_to_check = { ...getState().job };
//                                     job_to_check.QuoteParameters.ENGINEERING = new_engineering;
//                                     let warnings = JOBSTATE_VALIDATION.getWarnings(
//                                         job_to_check,
//                                         getState()?.app?.user,
//                                         getState()?.config
//                                     );
//                                     console.log("warnings", warnings);
//                                     if (warnings && warnings.warning)
//                                         dispatch({
//                                             type: SHOW_DESIGNER_MESSAGE,
//                                             message: warnings.message,
//                                         });
//                                 }, 1000);
//                             }

//                             dispatch({
//                                 type: UPDATE_2D_DESIGNER_SVGS,
//                                 parameter: "area_all",
//                                 value: svg_url,
//                             });
//                         }, 300);

//                         resolve(true);
//                         return;
//                     }

//                     dispatch(updateAPP("loadingEngineering", false));

//                     if (json.svg) {
//                         console.log("json.svg", json.svg);
//                         var svg_url = json["svg"];
//                         if ("Data" in json) {
//                             dispatch(updateQuoteParameters("AREA_DATA", json["Data"]));
//                         }
//                         if ("EngineeringResults" in json) {
//                             let new_engineering = {
//                                 ...getState().job.QuoteParameters.ENGINEERING,
//                                 ...json,
//                             };
//                             window.job = { ...getState().job };
//                             new_engineering.engineeringHashCode = GetShapeUpdateString();

//                             new_engineering.EngineeringResults = json["EngineeringResults"];
//                             dispatch(updateQuoteParameters("ENGINEERING", new_engineering));

//                             setTimeout(function () {
//                                 let job_to_check = { ...getState().job };
//                                 if (job_to_check?.QuoteParameters)
//                                     job_to_check.QuoteParameters.ENGINEERING = new_engineering;
//                                 let warnings = JOBSTATE_VALIDATION.getWarnings(
//                                     job_to_check,
//                                     getState()?.app?.user,
//                                     getState()?.config
//                                 );
//                                 console.log("warnings", warnings);
//                                 if (warnings && warnings.warning)
//                                     dispatch({
//                                         type: SHOW_DESIGNER_MESSAGE,
//                                         message: warnings.message,
//                                     });
//                             }, 1000);
//                         }
//                         console.log("post svg dipatch");

//                         if (json["svg_data"]) {
//                             // dispatch({
//                             //     type: TOGGLE_DESIGNER,
//                             //     parameter: SHOW_LOADING_BAR,
//                             //     value: false,
//                             // });
//                             // LoadSVGFromData(json["svg_data"]);
//                             // dispatch({
//                             //     type: UPDATE_2D_DESIGNER_SVGS,
//                             //     parameter: "area_all",
//                             //     value: svg_url,
//                             // });
//                         } else {
//                             dispatch({
//                                 type: UPDATE_2D_DESIGNER_SVGS,
//                                 parameter: "area_all",
//                                 value: svg_url,
//                             });
//                         }
//                         resolve(true);
//                     } else {
//                         dispatch({
//                             type: TOGGLE_DESIGNER,
//                             parameter: SHOW_LOADING_BAR,
//                             value: false,
//                         });
//                         resolve(false);
//                     }
//                 })
//                 .catch((e) => {
//                     if (e?.message?.includes && e.message.includes("aborted")) {
//                         console.log("ABORTED", e.message);
//                         return resolve(false);
//                     }
//                     console.log("ERROR", e.message);

//                     let message = "Error loading layout from QikQuote server.";
//                     if (typeof e === "string") message = e;
//                     if (e.message === "failed to fetch")
//                         message = "SERVER NOT REACHABLE. Check internet connection, then try again in a few minutes...";
//                     dispatch({
//                         type: TOGGLE_DESIGNER,
//                         parameter: SHOW_LOADING_BAR,
//                         value: false,
//                     });
//                     dispatch({
//                         type: SHOW_DESIGNER_MESSAGE,
//                         message: "Error: " + message,
//                     });
//                     return resolve(false);
//                     // handle errors and timeout error
//                 }); // parses JSON response into native Javascript objects
//         });
//     };

export const showDesignerMessage = (message) => (dispatch) => {
    dispatch({
        type: SHOW_DESIGNER_MESSAGE,
        message: message,
    });
};

export const update2DDesigner = (parameter, value) => (dispatch) => {
    console.log(UPDATE_2D_DESIGNER, parameter, value);
    dispatch({
        type: UPDATE_2D_DESIGNER,
        parameter: parameter,
        value: value,
    });
};
export const toggle2DDesigner = (parameter) => (dispatch) => {
    console.log(TOGGLE_2D_DESIGNER, parameter);
    dispatch({
        type: TOGGLE_2D_DESIGNER,
        parameter: parameter,
    });
};

export const update3DDesigner = (parameter, value) => (dispatch) => {
    console.log(UPDATE_3D_DESIGNER, parameter, value);
    dispatch({
        type: UPDATE_3D_DESIGNER,
        parameter: parameter,
        value: value,
    });
};
export const toggle3DDesigner = (parameter) => (dispatch) => {
    console.log(TOGGLE_3D_DESIGNER, parameter);
    dispatch({
        type: TOGGLE_3D_DESIGNER,
        parameter: parameter,
    });
};
